import { render, staticRenderFns } from "./product-unbundle.vue?vue&type=template&id=38ca29fb&scoped=true&"
import script from "./product-unbundle.vue?vue&type=script&lang=js&"
export * from "./product-unbundle.vue?vue&type=script&lang=js&"
import style0 from "./product-unbundle.vue?vue&type=style&index=0&id=38ca29fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca29fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ca29fb')) {
      api.createRecord('38ca29fb', component.options)
    } else {
      api.reload('38ca29fb', component.options)
    }
    module.hot.accept("./product-unbundle.vue?vue&type=template&id=38ca29fb&scoped=true&", function () {
      api.rerender('38ca29fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/product-unbundle.vue"
export default component.exports